export enum OverviewTabs {
  SUMMARY = 1,
  REPORTS = 2,
  BANK_RECONCILIATION = 3,
  BUSINESS_HISTORY = 4,
  TAX_BENCHMARKING = 5,
  DATA_UPLOADS = 6,
}
